import React, { useEffect } from "react";
import styles from "../styles/ED1.module.css";
import release from "../assets/pr.jpg";
import image from "../assets/Avatar.svg";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import deal from "../assets/deal.jpg";
import dash from "../assets/dasg.jpg";
import mobile from "../assets/mobile.JPG";
import about from "../assets/about.JPG";
import { useLocation } from "react-router-dom";

const EventDetail = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <Header />
      <div className={styles.eventDetailPage}>
        <div className={styles.container}>
          <div className={styles.maxWidth}>
            <div className={styles.eventHeader}>
              <p className={styles.reportDate}>Report - 19 Jan 2025</p>
              <h1 className={styles.eventTitle}>
                Safaricom M-PESA and Arifpay Sign Partnership Agreement
              </h1>
              <div className={styles.locationContainer}>
                <img src={image} alt="owner" className={styles.locationIcon} />
                <p className={styles.locationText}>Abebe Kebede</p>
              </div>
            </div>

            <div className={styles.eventImageContainer}>
              <img
                src={release}
                alt="Partnership Agreement Signing"
                className={styles.eventImage}
              />
            </div>

            <div className={styles.eventContent}>
              <p className={styles.paragraph}>
                The agreement enables customers and merchants to utilize M-PESA
                Services to make and receive different payments through
                Arifpay's online payment system and Arifpay Point-of-Sale
                (ArifPOS).
              </p>
              <p className={styles.paragraph}>
                Under this agreement, Arifpay will leverage its payment
                processing platform to integrate and enhance M-PESA services,
                ensuring a more robust and user-friendly experience for
                customers. This collaboration will enable Safaricom M-PESA users
                to enjoy an expanded range of digital financial services,
                Arifpay value-added services and enhance the accessibility and
                efficiency of M-PESA services.
              </p>

              <h2 className={styles.sectionTitle}>About Safaricom M-PESA:</h2>
              <p className={styles.paragraph}>
                Safaricom M-PESA Mobile Financial Services PLC, a subsidiary of
                Safaricom Ethiopia, received a Payment Instrument Issuer License
                from the National Bank of Ethiopia in May 2023 and went
                operational in August 2023. M-PESA provides quick and easy
                financial services to anyone with a mobile phone.
              </p>
              <Link to="/events" className={styles.backButton}>
                ← Back to Events
              </Link>
              <h2 className={styles.sectionTitle}>
                Versatility of Payment Forecasts
              </h2>
              <div className={styles.eventImageContainer}>
                <img
                  src={release}
                  alt="Partnership Agreement Signing"
                  className={styles.eventImage}
                />
              </div>

              <p className={styles.paragraph}>
                Arifpay is the first Payment System Operator licensed by the
                National Bank of Ethiopia as a dedicated Point of Sale (POS) and
                Payment Gateway Operator. Arifpay is positioned as a strategic
                partner to EthSwitch (the National Switch) which is key to
                enable payment interoperability. Arifpay is Financial
                Institution, offering innovative digital payment solutions with
                a level of security in line with national standards, laws and
                regulations set by the National Bank of Ethiopia.
              </p>

              <h2 className={styles.sectionTitle}>Conclusion</h2>
              <p className={styles.paragraph}>
                In a world that is perpetually evolving, being able to
                anticipate change is invaluable. Arifpay's Payment Forecasts
                provide businesses with the ability to gaze into the future,
                predictive analytics will continue to shape the strategic
                landscape, and with tools like Arifpay, businesses are poised to
                navigate through the uncertainties and possibilities that lie
                ahead.
              </p>
            </div>
          </div>
        </div>

        <div
          className={styles.pressReleasesSection}
          style={{ overflowX: "hidden" }}
        >
          <h2 className={styles.pressReleasesTitle}>Related posts</h2>
          <div
            className={styles.pressReleasesGrid}
            style={{ overflowX: "hidden" }}
          >
            <div
              className={styles.pressReleaseCard}
              style={{ overflowX: "hidden" }}
            >
              <img
                src={deal}
                alt="The deal for one and on only"
                className={styles.pressReleaseImage}
              />
              <p className={styles.pressReleaseReport}>Report</p>
              <h3 className={styles.pressReleaseHeadline}>
                The deal for one and on only
              </h3>
            </div>
            <div
              className={styles.pressReleaseCard}
              style={{ overflowX: "hidden" }}
            >
              <img
                src={dash}
                alt="The New realse of Arifpay dashbord"
                className={styles.pressReleaseImage}
              />
              <p className={styles.pressReleaseReport}>Report</p>
              <h3 className={styles.pressReleaseHeadline}>
                The New realse of Arifpay dashbord
              </h3>
            </div>
            <div
              className={styles.pressReleaseCard}
              style={{ overflowX: "hidden" }}
            >
              <img
                src={mobile}
                alt="Have a look at our 2025 Journey"
                className={styles.pressReleaseImage}
              />
              <p className={styles.pressReleaseReport}>Report</p>
              <h3 className={styles.pressReleaseHeadline}>
                Have a look at our 2025 Journey
              </h3>
            </div>
            <div
              className={styles.pressReleaseCard}
              style={{ overflowX: "hidden" }}
            >
              <img
                src={about}
                alt="The new update on our pos machine integration for you"
                className={styles.pressReleaseImage}
              />
              <p className={styles.pressReleaseReport}>Report</p>
              <h3 className={styles.pressReleaseHeadline}>
                The new update on our pos machine integration for you
              </h3>
            </div>
          </div>

          <button className={styles.readMoreButton}>
            <a
              href="/PressRelease"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Read More →
            </a>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventDetail;
